import React, { useMemo } from "react";
import { useTable, useSortBy, useGlobalFilter, usePagination } from "react-table";
import { ChevronRightIcon, ChevronLeftIcon } from '@heroicons/react/outline'
import { ChevronUpIcon } from '@heroicons/react/solid'
import GlobalFilter from "./GlobalFilter";

const Table = ({ openModal, columnsProp, dataProp, additionalColumn }) => {

    const columnsFull = () => {
        if (additionalColumn) {
            return (
                [
                    ...columnsProp,
                    additionalColumn
                ]
            )
        }
        return [...columnsProp];
    }


    const handler = (row) => {
        openModal(row);
    };

    const columns = useMemo(() => columnsFull(), []);
    const data = useMemo(() => dataProp, [dataProp])

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow,
        nextPage,
        previousPage,
        canNextPage,
        canPreviousPage,
        pageOptions,
        pageCount,
        setPageSize,
        state,
        setGlobalFilter } = useTable({
            columns,
            data,
            initialState: {
                pageSize: 10,
                sortBy: [
                    {
                        id: 'personalCardNumber',
                        desc: true
                    }
                ]
            }
        },
            useGlobalFilter,
            useSortBy,
            usePagination
        );

    const { globalFilter, pageIndex, pageSize } = state;

    return (
        <>
            <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
            <div className="rounded overflow-hidden bg-white shadow-table">
                <div className=" overflow-x-auto min-h-[340px]">

                    <table {...getTableProps()} className="w-full">
                        <thead className="relative shadow before:absolute before:top-1/2 before:-translate-y-1/2 before:left-0 before:h-6 before:w-0.5 md:before:w-0.5 before:bg-blueSecondary">
                            {
                                headerGroups.map((headerGroup) => (
                                    <tr {...headerGroup.getHeaderGroupProps()}>
                                        {
                                            headerGroup.headers.map(column => (
                                                <th {...column.getHeaderProps(column.getSortByToggleProps())} {...column.getHeaderProps()} className="py-2 px-2 xl:px-2 text-left bg-white text-xs font-semibold whitespace-nowrap">
                                                    <div className="flex items-center">
                                                        {column.render('Header')}
                                                        <span>
                                                            <ChevronUpIcon className={`w-3 h-3 ml-2 ${column.isSorted ? (column.isSortedDesc ? 'opacity-100 rotate-180' : 'opacity-100') : 'opacity-0'}`} />
                                                        </span>
                                                    </div>
                                                </th>
                                            ))
                                        }
                                    </tr>
                                ))
                            }

                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {
                                page.map(row => {
                                    prepareRow(row);
                                    return (
                                        <tr {...row.getRowProps()} className="border border-t-0 border-b-1 border-gray-100 last:border-0 text-gray-700 hover:bg-bluePrimary/10  transition animate-fadeIn">
                                            {
                                                row.cells.map((cell, index) => {
                                                    if (index === row.cells.length - 1) {
                                                        return <td {...cell.getCellProps()} className="max-w-[200px] min-w-[150px] py-3 px-2 xl:px-4 font-medium text-sm">{cell.render('Cell')}</td>
                                                    }
                                                    return <td {...cell.getCellProps()} onClick={() => handler(row)} className="max-w-[200px] min-w-[150px] py-3 px-2 xl:px-4 font-medium text-sm">{cell.render('Cell')}</td>
                                                })
                                            }
                                        </tr>
                                    )
                                })
                            }

                        </tbody>
                    </table>
                </div>
                {pageCount ?
                    <div className="w-full flex items-center py-3 px-2 xl:px-4 text-xs text-gray-500 font-medium shadow-[0_-1px_3px_0_rgba(0,0,0,0.1)]">
                        <div className="mr-auto">
                            <label htmlFor="pageSize" className="mr-1.5">Broj redova</label>
                            <select id="pageSize" value={pageSize} onChange={e => setPageSize(Number(e.target.value))} className="p-1 rounded bg-gray-50">
                                {
                                    [5, 10, 20, 50].map(pageSize => (
                                        <option key={pageSize} value={pageSize}>
                                            {pageSize}
                                        </option>
                                    ))
                                }
                            </select>
                        </div>
                        <span>
                            Stranica <strong>{pageIndex + 1} od {pageOptions.length}</strong>

                        </span>
                        <div className="ml-auto">
                            <button onClick={() => previousPage()} className={`p-1.5 rounded-full bg-secondaryGradient mr-3 transition ${canPreviousPage ? 'cursor-pointer' : 'opacity-50'}`} title="Prethodna stranica" disabled={!canPreviousPage}><ChevronLeftIcon className="w-5 h-5 text-white" /></button>
                            <button onClick={() => nextPage()} className={`p-1.5 rounded-full bg-secondaryGradient transition ${canNextPage ? 'cursor-pointer' : 'opacity-50'}`} title="Sledeća stranica" disabled={!canNextPage}><ChevronRightIcon className="w-5 h-5 text-white" /></button>
                        </div>

                    </div>
                    :
                    ''
                }
            </div>
        </>
    )
};

export default Table;
